import parser from 'html-react-parser';

export {parser};
